<template>
  <div class="sidebar">
    <div class="mb2">
      <router-link class="link pa2 pl0 flex items-center w-100" :to="{name: 'home'}">
        <span class="icon mr1 text--theme-highlight flex items-center">
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 8"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g
                transform="translate(8.000000, 4.000000) rotate(-180.000000) translate(-8.000000, -4.000000) translate(-4.000000, -8.000000)"
              >
                <polygon points="0 0 24 0 24 24 0 24"></polygon>
                <polygon
                  class="polygon"
                  fill="#000000"
                  points="16.01 11 4 11 4 13 16.01 13 16.01 16 20 12 16.01 8"
                ></polygon>
              </g>
            </g>
          </svg>
        </span>
        <span class="text--theme-highlight">{{$t('sidebarTopLink')}}</span>
      </router-link>
    </div>
    <div class="sidebar__links ba b--gray pv3">
      <ul class="list pa0 ma0">
        <li @click="trackPageClick(`sidebar_using_sitename`)">
          <router-link
            class="link no-underline"
            :to="{name: `using-site`}"
          >{{getTitle('using-site')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_billing_support`)">
          <router-link
            class="link no-underline"
            :to="{name: 'billing-support'}"
          >{{getTitle('billing-support')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_account_support`)">
          <router-link
            class="link no-underline"
            :to="{name: 'account-support'}"
          >{{getTitle('account-support')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_technical_support`)">
          <router-link
            class="link no-underline"
            :to="{name: 'technical-support'}"
          >{{getTitle('technical-support')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_partners_authors`)">
          <router-link
            class="link no-underline"
            :to="{name: 'partners-authors'}"
          >{{getTitle('partners-authors')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_faq`)">
          <router-link
              class="link no-underline"
              :to="{name: 'faq'}"
          >{{getTitle('faq')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_announcements`)">
          <router-link
              class="link no-underline"
              :to="{name: 'announcements'}"
          >{{getTitle('announcements')}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getCategoryPageName, trackPageClick } from '@/utils/common';

export default {
  computed: {
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    categories() {
      return this.$store.state.categories;
    }
  },
  methods: {
    getCategoryName(categoryId) {
      return getCategoryPageName(categoryId, this.$store.state.flowObject.pages);
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    },
    getTitle(pageName) {
      return this.$store.state.categories[this.$store.state.flowObject.pages[pageName].meta.categoryId] && this.$store.state.categories[this.$store.state.flowObject.pages[pageName].meta.categoryId].title;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

span.text--theme-highlight:nth-child(2) {
  font-weight: 400;
}
.sidebar {
  .icon .polygon {
    fill: $theme-highlight;
  }
}
.sidebar__links {
  background-color: #fff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  position: relative;

  ul li {
    margin-bottom: 1rem;
  }
  .link {
    color: #101218 !important;
    display: block;
    padding: 0.2em 1.3em;
    border-left: 3px solid transparent;

    &:hover {
      // &.router-link-exact-active {
      color: #F04682 !important;
      border-left: 3px solid #F04682;
    }
  }
}

@media (min-width: 641px) and (max-width: 832px) {
  .link {
    padding-right: 0;
  }
}

*{
  font-family: 'Source Sans Pro',Arial, Helvetica, sans-serif!important;
  color:#fff!important;
}

html, body {
  background-color: #fbfbfb;
}

a {
  color: #F04682!important;
}

a:hover {
  border-color: #F04682!important;
}

.header {
  padding: 0 30px 30px 30px;
  background-color: #101218;
  margin-bottom:50px!important;
}

.sidebar .icon .polygon{
  fill: #F04682!important;
}
.sidebar a { color:#F04682!important;}
.sidebar span { color:#F04682!important;}
.input-group--search{
  background-color: transparent!important;
}


.input-group--search .input {
  border-radius: 5px;
  background-color: #ffffff;
  color:#101218!important;
  border: 1px solid rgba($color: #ffffff, $alpha: 0.1)!important;
  padding-left: 45px!important;
}

.input-group--search .input::placeholder { color: rgba($color: #101218, $alpha: 0.5)!important;}
.autocomplete-results {background-color: #31343E!important; border-color: rgba($color: #ffffff, $alpha: 0.1)!important;}

.input-group--search .icon {
  background-color: transparent!important;
  float: left!important;
  display: inline-block;
  left:1rem!important;
  top: 66%!important;
}

.category-boxes__item__link {
  background-color: #ffffff;
  color:#101218!important;
}
.category-boxes__item__link a, .category-boxes__item__link h3, .category-boxes__item__link p {
  color:#101218!important;
}

.category-boxes__item__link p { font-weight: 500;}

.category-boxes__item__link:hover {
  background-color:#fff!important;
  color:#101218!important;
}

.category-boxes__item__link:hover * {
  color:#101218!important;
}

h1.stage__title {
  text-transform: none!important;
}

.category-boxes__item__link .icon polygon, .category-boxes__item__link .icon path {
  fill: #F04682!important;
}

.footer__header {
  background-color: #ecece8!important;
  color: #101218!important;
  border : none!important;
}
.footer__header p { color:#101218!important;}

.footer__item__link {
  border-radius: 5px!important;
  border: 1px solid #ddddd9!important;
  background-color:#ffffff!important;
  color:#101218!important;
}

.footer__item__link h4 {
  color:#101218!important;
}

.footer__item__modals, .footer__item__modals h2{
  color:#101218!important;
}

.footer__modal-option::after {
  color:#F04682!important;
}

.footer__modal-link-text {
  background-color: #F04682!important;
}

.footer__modal-title{
  color: #101218!important;
}

.footer { margin-top: 140px!important;}



.language-dropdown__list .text, .language-dropdown__list .link { color:#101218!important; }

.ma0 { font-weight: 700; }
.stage__text .link { font-weight: 600;}

.content__main { padding:20px!important; border-radius: 5px; background-color: #ffffff; color:#101218!important; border: 1px solid #eeeeee;}
.articles .title { color:#101218!important; }
.content__main h1 { color:#101218!important; }
.article-body, .article-body * { color:#101218!important; font-weight: 600;}
.content__aside .sidebar__links { background-color: #fff; border: 1px solid #eeeeee; border-radius: 5px; position: relative;}
.footer__modal-option a { font-weight: 600!important;}
.footer__modal-link { border-radius: 5px; }

// Contact page,  Links in articles
.article-body, .article-body a { color:#F04682!important;}


.row-container * { color:#101218!important}
.row-container a { color:#F04682!important}
.stage__text .stage__text__question { color:#fff!important; }
.input-group--btns { margin: 5px 0 20px!important; padding:0!important}
.input-group--btns button {background-color: #F04682!important; color:#fff!important; font-weight: 600!important;}

</style>
